import React from "react";
import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonList,
} from "@ionic/react";
import "../theme/AppStyles.css";
import { SpecificScheduler } from "./SpecificScheduler";


export const SchedulerDashboard: React.FC<any> = (jobsSummary) => {
  const [selectedSchedulerUID, setSelectedSchedulerUID] = React.useState("");
  const [selectedSchedulerName, setSelectedSchedulerName] = React.useState("");
  const [selectedOpenJobs, setSelectedOpenJobs] = React.useState(0);
  const [selectedFilledJobs, setSelectedFilledJobs] = React.useState(0);
  const [selectedPastJobs, setSelectedPastJobs] = React.useState(0);

  // console.log("Jobs Summary in Admin Dashboard:", jobsSummary);
  // console.log("SchedulerDashboard");

  const handleSchedulerClick = (e: any) => {
    const schedulerUID = e.currentTarget.getAttribute("data-scheduler-uid");
    const schedulerName = e.currentTarget.getAttribute("data-scheduler-name");
    const openJobs = e.currentTarget.getAttribute("data-scheduler-open-jobs");
    const filledJobs = e.currentTarget.getAttribute("data-scheduler-filled-jobs");
    const pastJobs = e.currentTarget.getAttribute("data-scheduler-past-jobs");

    // console.log("Clicked Scheduler UID:", schedulerUID);
    // console.log("Clicked Scheduler Name:", schedulerName);
    setSelectedSchedulerUID(schedulerUID);
    setSelectedSchedulerName(schedulerName);
    setSelectedOpenJobs(parseInt(openJobs));
    setSelectedFilledJobs(parseInt(filledJobs));
    setSelectedPastJobs(parseInt(pastJobs));

    // history.push(`/admin/scheduler/${schedulerUID}`);
  };



  return (
    <React.Fragment>

      {selectedSchedulerUID!== "" && 
        <SpecificScheduler 
          schedulerUID={selectedSchedulerUID} 
          schedulerName={selectedSchedulerName} 
          openJobs={selectedOpenJobs} 
          filledJobs={selectedFilledJobs} 
          pastJobs={selectedPastJobs}
        />
      }
      {selectedSchedulerUID === "" &&  

    <IonList>
        {jobsSummary.jobsSummary
          .map((scheduler: {
              schedulerUID: string;
              schedulerName: string;
              schedulerPICURL: string;
              jobsOpen: string;
              jobsFilled: string;
              jobsPast: string;
              totalJobs: boolean;
          }) => (
              <IonItem 
                key={scheduler.schedulerUID} 
                onClick={handleSchedulerClick}
                data-scheduler-uid={scheduler.schedulerUID}
                data-scheduler-name={scheduler.schedulerName}
                data-scheduler-open-jobs={scheduler.jobsOpen}
                data-scheduler-filled-jobs={scheduler.jobsFilled}
                data-scheduler-past-jobs={scheduler.jobsPast}
                data-scheduler-total-jobs={scheduler.totalJobs}
              >
                  <IonAvatar 
                    className="avatario"
                    slot="start"
                  >
                    <img src={scheduler.schedulerPICURL} alt="" />
                  </IonAvatar>
                  <IonLabel className="labelo">
                    <h2>
                      {scheduler.schedulerName}
                    </h2>
                  <p>jobs Open: {scheduler.jobsOpen}</p>
                  <p>jobs Filled: {scheduler.jobsFilled}</p>
                  <p>jobs Past: {scheduler.jobsPast}</p>
                  <p>Total Jobs: {scheduler.totalJobs}</p>
                <br></br>
              </IonLabel>
            </IonItem>
          ))}
      </IonList>    
  }   
    </React.Fragment>
  );
}
